var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("3、不同形态的资产的流动性不同，其获利能力也就不同，下面说法中正确的是（　）。")]),_vm._v("A、流动性越高，其获利能力可能越高 "),_c('br'),_c('br'),_vm._v("B、流动性越高，其获利能力可能越低 "),_c('br'),_c('br'),_vm._v("C、流动性越低，其获利能力可能越低 "),_c('br'),_c('br'),_vm._v("D、资产的获利能力与流动性成正比 ")])
}]

export { render, staticRenderFns }